const personalMobMenu = () => {
   
    const menuBtn = document.querySelector('[data-btn="mob-menu-account"]'),
          mobMenu = document.querySelector('[data-block="mob-menu-account"]');

    try {
        menuBtn.addEventListener('click', ()=>{
            mobMenu.classList.add('active');
            mobMenu.classList.add('fade-in-left');
            document.body.style.overflow = 'hidden';
            addEventListener('click', closeMenu);

            let div = document.createElement('div');
            div.classList.add('overlay-close');
            div.style.cssText = `
                position: fixed;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 4;
            `;
            document.body.append(div);
        });
    } catch(e){}

    function closeMenu(e) {
        let target = e.target;
        if(target.classList.contains('close-menu') || target.classList.contains('overlay-close')) {
            
            mobMenu.classList.remove('active');
            mobMenu.classList.remove('fade-in-left');
            document.body.style.overflow = 'auto';
            document.querySelector('.overlay-close').remove();
            removeEventListener('click', closeMenu);
        }
    }
};

export default personalMobMenu;